// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__H2jKl","row":"styles_row__1hqIH"};